import { render, staticRenderFns } from "./divvyAdminModal.vue?vue&type=template&id=1ffd0c72&"
import script from "./divvyAdminModal.vue?vue&type=script&lang=js&"
export * from "./divvyAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./divvyAdminModal.vue?vue&type=style&index=0&id=1ffd0c72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports